import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: {
          label: label.page.dashboard,
          requiresAuth: true,
        },
        component: () => import("@/views/pages/Dashboard"),
      },
      {
        path: "profile",
        name: "Profile",
        meta: {
          label: label.page.profile,
          requiresAuth: true,
        },
        component: () => import("@/views/auth/Profile"),
      },

      // Persons and Users Routing System ---------------------------------------------------------
      {
        path: "users",
        name: "Users",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/users/roles",
        children: [
          {
            path: "roles",
            name: "Roles",
            meta: {
              label: label.page.RolesAccess,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/users/Roles"),
          },
          {
            path: "usersManagement",
            name: "UsersManagement",
            meta: {
              label: "مدیریت کاربران",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/users/index"),
          },
          {
            path: "customersManagement",
            name: "CustomersManagement",
            meta: {
              label: "مدیریت مشتریان",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/users/CustomerIndex"),
          },
        ],
      },
      // Base Informations Routing System ---------------------------------------------------------
      {
        path: "base",
        name: "Base",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/basicInfo/fileManagement",
        children: [
          {
            path: "fileManagement",
            name: "FileManagement",
            component: () => import("@/views/pages/base/fileManagement"),
            meta: {
              label: label.router.FileManagement,
              requiresAuth: true,
            },
          },
          {
            path: "categories",
            name: "Categories",
            meta: {
              label: label.page.Categories,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/categories"),
          },
          {
            path: "ticket/category",
            name: "TicketCategory",
            component: () => import("@/views/pages/base/ticketCategory"),
            meta: {
              label: label.router.TicketCategory,
              requiresAuth: true,
            },
          },
          {
            path: "unit",
            name: "TheUnit",
            component: () => import("@/views/pages/base/unit/index.vue"),
            meta: {
              label: label.router.TheUnit,
              requiresAuth: true,
            },
          },
          {
            path: "config",
            name: "Config",
            meta: {
              label: "اطلاعات وبسایت",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/Config"),
          },
          {
            path: "cars",
            name: "Cars",
            meta: {
              label: "مدیریت خودرو ها",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/cars/index.vue"),
          },
          {
            path: "saleType",
            name: "SaleType",
            meta: {
              label: "مدیریت انواع فروش",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/saleType/index.vue"),
          },
          {
            path: "ordersSetting",
            name: "OrdersSetting",
            meta: {
              label: "تنظیمات سفارشات",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/ordersSetting/index.vue"),
          },
        ],
      },
      // blogs ---------------------------------------------------------
      {
        path: "blog",
        name: "Blog",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "blog/list",
        children: [
          {
            path: "add",
            name: "AddBlog",
            component: () => import("@/views/pages/blog/Add.vue"),
            meta: {
              label: label.page.addBlog,
              requiresAuth: true,
            },
          },
          {
            path: "list",
            name: "TheBlogs",
            meta: {
              label: label.page.manageBlogs,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/blog/List.vue"),
          },
          {
            path: "editBlog/:id",
            name: "EditBlog",
            component: () => import("@/views/pages/blog/Edit"),
            meta: {
              label: label.router.EditBlog,
              requiresAuth: true,
            },
          },
        ],
      },
      // Comments ---------------------------------------------------------
      {
        path: "comments",
        name: "Comments",
        meta: {
          label: label.router.ManageComments,
          requiresAuth: true,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/comments",
        children: [
          {
            path: "comments/blog",
            name: "BlogComments",
            component: () => import("@/views/pages/comments/BlogComments"),
            meta: {
              label: label.router.BlogComments,
              requiresAuth: true,
            },
          },
          {
            path: "comments/product",
            name: "ProductComments",
            component: () => import("@/views/pages/comments/ProductComments"),
            meta: {
              label: label.router.ProductComments,
              requiresAuth: true,
            },
          },
        ],
      },
      // services ---------------------------------------------------------
      {
        path: "service",
        name: "Service",
        meta: {
          label: label.router.Service,
          requiresAuth: true,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/services/list",
        children: [
          {
            path: "list",
            name: "ServicesList",
            component: () => import("@/views/pages/services/List"),
            meta: {
              label: label.router.ManageServices,
              requiresAuth: true,
            },
          },
          {
            path: "addService",
            name: "AddService",
            component: () => import("@/views/pages/services/Add"),
            meta: {
              label: label.router.AddService,
              requiresAuth: true,
            },
          },
          {
            path: "editService/:id",
            name: "EditService",
            component: () => import("@/views/pages/services/Edit"),
            meta: {
              label: label.router.EditServices,
              requiresAuth: true,
            },
          },
        ],
      },

      {
        path: "orders",
        name: "Orders",
        meta: {
          requiresAuth: true,
          label: "سفارشات",
        },
        component: () => import("@/views/pages/services/products/index"),
      },
      {
        path: "transaction",
        name: "Transaction",
        meta: {
          requiresAuth: true,
          label: "تراکنش ها و پرداخت ها",
        },
        component: () =>
          import("@/views/pages/services/products/Transaction.vue"),
      },
      {
        path: "features",
        name: "ProductFeatures",
        component: () => import("@/views/pages/services/products/Features.vue"),
        meta: {
          label: "ویژگی‌های محصول",
          requiresAuth: true,
        },
      },
      {
        path: "returnedOrders",
        name: "ReturnedOrders",
        component: () => import("@/views/pages/returnedOrders"),
        meta: {
          label: label.router.ReturnedOrders,
          requiresAuth: true,
        },
      },
      // products --------------------------------------------------------
      {
        path: "products",
        name: "Products",
        meta: {
          label: label.router.Products,
          requiresAuth: true,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/products/list",
        children: [
          {
            path: "list",
            name: "ProductsList",
            component: () => import("@/views/pages/products/List"),
            meta: {
              label: label.router.ProductsList,
              requiresAuth: true,
            },
          },
          {
            path: "add",
            name: "AddProduct",
            component: () => import("@/views/pages/products/Add"),
            meta: {
              label: label.router.AddProduct,
              requiresAuth: true,
            },
          },
          {
            path: "edit/:id",
            name: "EditProduct",
            component: () => import("@/views/pages/products/Edit"),
            meta: {
              label: label.router.EditProduct,
              requiresAuth: true,
            },
          },
        ],
      },

      // tickets ---------------------------------------------------------
      {
        path: "tickets",
        name: "TicketsList",
        meta: {
          requiresAuth: true,
          label: label.router.Tickets,
        },
        component: () => import("@/views/pages/tickets"),
      },
      // visitors ---------------------------------------------------------
      {
        path: "visitors",
        name: "Visitors",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/visitors/branches",
        children: [
          {
            path: "branches",
            name: "Branches",
            component: () => import("@/views/pages/visitors/index"),
            meta: {
              label: "درخواست های نمایندگی",
              requiresAuth: true,
            },
          },
        ],
      },
      // Brands ---------------------------------------------------------
      {
        path: "brands",
        name: "Brands",
        meta: {
          label: label.router.Brands,
          requiresAuth: true,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "list",
            name: "BrandsList",
            component: () => import("@/views/pages/brands"),
            meta: {
              label: label.router.ManageBrands,
              requiresAuth: true,
            },
          },
          {
            path: "addBrand",
            name: "AddBrand",
            component: () => import("@/views/pages/brands/Add"),
            meta: {
              label: label.router.AddBrand,
              requiresAuth: true,
            },
          },
          {
            path: "editBrand/:id",
            name: "EditBrand",
            component: () => import("@/views/pages/brands/Edit"),
            meta: {
              label: label.router.EditBrand,
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "discounts",
        name: "ManageDiscounts",
        meta: {
          label: "جشنواره و تخفیفات",
          requiresAuth: true,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/discounts/list",
        children: [
          {
            path: "list",
            name: "ListFestivals",
            component: () => import("@/views/pages/discounts/ListFestivals"),
            meta: {
              label: "لیست جشنواره‌ها",
              requiresAuth: true,
            },
          },
          {
            path: "polls",
            name: "PollsList",
            component: () => import("@/views/pages/polls/List"),
            meta: {
              label: "نظرسنجی",
              requiresAuth: true,
            },
          },
          {
            path: "addPoll",
            name: "AddPolls",
            component: () => import("@/views/pages/polls/Add"),
            meta: {
              label: "افزودن نظرسنجی",
              requiresAuth: true,
            },
          },
          {
            path: "detailPoll/:id",
            name: "DetailPolls",
            component: () => import("@/views/pages/polls/Detail"),
            meta: {
              label: "جزئیات نظرسنجی",
              requiresAuth: true,
            },
          },
        ],
      },

      // Sale - بازرگانی و فروش -------------------------------------------------------------------------------------------
      {
        path: "psale",
        name: "PSale",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/PSale/buy",
        children: [
          {
            path: "buy",
            name: "Buy",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/psale/buy/list",
            children: [
              {
                path: "list",
                name: "BuyList",
                meta: {
                  label: label.page.Buy,
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/sale/buy/index"),
              },
              {
                path: "add",
                name: "AddBuy",
                meta: {
                  label: label.page.AddBuy,
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/sale/buy/Add"),
              },
              {
                path: "edit/:id",
                name: "EditBuy",
                meta: {
                  label: label.page.EditBuy,
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/sale/buy/Edit"),
              },
            ],
          },
        ],
      },
      // appearance -  ظاهر و صفحات ------------------------------------------------------------------------------------
      {
        path: "appearance",
        name: "Appearance",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/appearance/bannersAndSliders",
        children: [
          {
            path: "bannersAndSliders",
            name: "BannersAndSliders",
            component: () => import("@/views/pages/appearance"),
            meta: {
              label: "بنر و اسلایدر",
              requiresAuth: true,
            },
          },
          {
            path: "socialNetworks",
            name: "SocialNetworks",
            component: () => import("@/views/pages/appearance/SocialNetwork"),
            meta: {
              label: "شبکه های اجتماعی",
              requiresAuth: true,
            },
          },
          {
            path: "menus",
            name: "Menus",
            component: () => import("@/views/pages/appearance/Menus"),
            meta: {
              label: "منو ها",
              requiresAuth: true,
            },
          },
          {
            path: "poster",
            name: "Poster",
            component: () => import("@/views/pages/appearance/Poster"),
            meta: {
              label: "پوستر ها",
              requiresAuth: true,
            },
          },
          {
            path: "widgets",
            name: "Widgets",
            component: () => import("@/views/pages/appearance/Widgets"),
            meta: {
              label: "ویجت ها",
              requiresAuth: true,
            },
          },
          {
            path: "pages",
            name: "Pages",
            meta: {
              label: label.router.Pages,
              requiresAuth: true,
            },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/appearance/managePages/ManagePages",
            children: [
              {
                path: "managePages",
                name: "ManagePages",
                component: () =>
                  import("@/views/pages/appearance/managePages/ManagePages"),
                meta: {
                  label: "مدیریت صفحات",
                  requiresAuth: true,
                },
              },
              {
                path: "AddPage",
                name: "AddPage",
                component: () =>
                  import("@/views/pages/appearance/managePages/AddPage"),
                meta: {
                  label: "اضافه کردن صفحه جدید",
                  requiresAuth: true,
                },
              },
              {
                path: "editPage",
                name: "EditPage",
                component: () =>
                  import("@/views/pages/appearance/managePages/EditPage"),
                meta: {
                  label: "ویرایش صفحه",
                  requiresAuth: true,
                },
              },
            ],
          },
        ],
      },

      // Report -  گزارشات ------------------------------------------------------------------------------------
      {
        path: "reports",
        name: "Report",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/reports/reportSalary",
        children: [
          {
            path: "salesOfficeByCommodity",
            name: "SalesOfficeByCommodity",
            meta: {
              label: label.page.SalesOfficeByCommodity,
              requiresAuth: true,
            },
            component: () =>
              import("@/views/pages/report/salesOfficeByCommodity/index"),
          },
          {
            path: "consumingMaterial",
            name: "ConsumingMaterial",
            meta: {
              label: label.page.ConsumingMaterial,
              requiresAuth: true,
            },
            component: () =>
              import("@/views/pages/report/consumingMaterial/index"),
          },
        ],
      },
      
      // NewsLetter -----------------------------------------------------------------------------
      {
        path: "newsLetter",
        name: "NewsLetter",
        component: () => import("@/views/pages/visitors/NewsLetter.vue"),
        meta: {
          label: "خبرنامه",
          requiresAuth: true,
        },
      },
      // contactUs -  مدیریت تماس با ما --------------------------------------------------------------------------------
      {
        path: "messages",
        name: "GuestContactMessage",
        component: () => import("@/views/pages/contactUs"),
        meta: {
          label: "پیام‌های کاربران مهمان",
          requiresAuth: true,
        },
      },
      // end of Container
    ],
  },

  // other Pages - without container
  {
    path: "/login",
    name: "Login",
    meta: {
      label: label.page.login,
    },
    component: () => import("@/views/auth/Login"),
    beforeEnter(to, from, next) {
      GlobalGuards.login(to, from, next);
    },
  },

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
